
import { supabase } from "@/integrations/supabase/client";

export const fetchPlanData = async (planId: string) => {
  console.log("Fetching optimized plan data for:", planId);
  
  const { data: plan, error } = await supabase
    .from("workout_plans")
    .select("id, name, description, is_personal, mode, created_by")
    .eq("id", planId)
    .single();

  if (error) {
    console.error("Error fetching plan data:", error);
    throw error;
  }

  return plan;
};
